import { useRef, useEffect } from 'react';

var useActiveElement = function useActiveElement(isModalActive) {
  var focusedElRef = useRef(document.activeElement || document.body);
  useEffect(function () {
    // If modal visibility updates, check for an active el
    if (isModalActive) {
      var focusedEl = document.activeElement || document.body;
      var prevFocusedEl = focusedElRef.current;
      if (prevFocusedEl !== focusedEl) {
        // if different, update reference manually
        focusedElRef.current = focusedEl;
      }
    }
  }, [isModalActive]);
  return focusedElRef;
};

export { useActiveElement as default };
